export default {
  methods: {
    updateEdited (mvcPaths) {
      const paths = this.mvcPathToPath(mvcPaths)

      this.updatePaths(paths)
    },
    addTrianglePaths () {
      const bounds = this.$refs.mapRef.$mapObject.getBounds()
      const northEast = bounds.getNorthEast()
      const southWest = bounds.getSouthWest()
      const center = bounds.getCenter()
      const degree = this.paths.length + 1
      const f = Math.pow(0.66, degree)

      const trianglePaths = [
        { lng: center.lng(), lat: (1 - f) * center.lat() + (f) * northEast.lat() },
        { lng: (1 - f) * center.lng() + (f) * southWest.lng(), lat: (1 - f) * center.lat() + (f) * southWest.lat() },
        { lng: (1 - f) * center.lng() + (f) * northEast.lng(), lat: (1 - f) * center.lat() + (f) * southWest.lat() }
      ]

      this.updatePaths(trianglePaths)
    },
    removePath () {
      this.updatePaths([])
    },
    handleClickForDelete ($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject.getPaths().getAt($event.path).removeAt($event.vertex)
      }
    },
    mvcPathToPath (mvcPaths) {
      const paths = []

      for (let i = 0; i < mvcPaths.getLength(); i++) {
        const path = []

        for (let j = 0; j < mvcPaths.getAt(i).getLength(); j++) {
          const point = mvcPaths.getAt(i).getAt(j)

          path.push({ lat: point.lat(), lng: point.lng() })
        }

        paths.push(path)
      }

      return paths
    },
    updatePaths (paths) {
      this.$emit('update:paths', paths)
    }
  }
}
